import { Component, OnInit } from '@angular/core';

import { YouTubePlayerModule } from '@angular/youtube-player';
import { TranslateModule } from '@ngx-translate/core';
import { SeoService } from '../services/seo.service';
@Component({
  selector: 'app-manual',
  imports: [YouTubePlayerModule, TranslateModule],
  standalone: true,
  templateUrl: './manual.component.html',
  styleUrl: './manual.component.scss'
})
export class ManualComponent implements OnInit  {
isDayMode = true;
videoAC = "https://youtu.be/53IV4Xc2Jxs";
videoGP="https://youtu.be/nxp8AAMx7pY";
maxWidth = 800;

constructor(private seo: SeoService) {}

getFrameVideo(videoUrl: string): string {
  if (!videoUrl) return '';

  // Extrahuj část za posledním lomítkem
  const lastPart = videoUrl.substring(videoUrl.lastIndexOf('/') + 1);

  // Odstraň query parametry za '?'
  const cleanId = lastPart.split('?')[0];

  return cleanId;
}

  initYoutube(){
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
  }


  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Návod - Asset Allocation Calculator',
      description: 'Návod k použití Asset Allocation Calculator. Naučte se analyzovat investiční portfolia, porovnávat fondy a modelovat investiční strategie.',
      keywords: 'návod, asset allocation calculator, tutoriál, investiční nástroje, analýza portfolia',
      url: '/instructions'
    });
    
    this.initYoutube();
  }

  getWidth(): number {
    const containerWidth = document.body.offsetWidth;
    const padding = 40; // padding z CSS
    const gap = 40; // gap mezi videi
    
    if (containerWidth < 768) {
      // Na mobilu: plná šířka minus padding
      return Math.min(containerWidth - padding, 600);
    } else {
      // Na desktopu: polovina šířky minus gap a padding
      return Math.min((containerWidth - gap - padding) / 2, 400);
    }
  }

  getHeight(): number {
    // Zachováme 16:9 poměr
    return this.getWidth() * (9 / 16);
  }
}
